import React from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import PropTypes from "prop-types";
import ReactStars from "react-rating-stars-component";
import {OverlayPanel} from "primereact/overlaypanel";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHTextField from "../../general/DHTextField";
import DHButtonSave from "../../general/DHButtonSave";

class DeineDatenAendern extends React.Component {

    constructor(props) {
        super(props);

        this.state = {...props.profil};

        this.save = this.save.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.showError = this.showError.bind(this);
        this.showInfo = this.showInfo.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState({...this.props.profil});
        }
    }

    showInfo(message) {
        this.setState({infoMessage: message});
    }

    showError(message) {
        this.setState({errorMessage: message});
    }


    handleChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    save() {
        this.showError(undefined);
        if( this.state.password !== this.state.password2) {
            this.showError("Die beiden neuen Passwörter stimmen nicht überein.");
            return;
        }
        let data = {...this.state};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.user + "/changeStammdaten",
            data,
            json => {
                this.showInfo("Speichern der Daten war erfolgreich!");
                this.props.callbackRefresh();

            },
            responseNotOk => {
                this.showError("Fehler: " + responseNotOk.message);
            },
            error => {
                this.showError("Fehler: " + error.message);
            }
        );
    }

    render() {
        return <div className="ligashortoverview"
                    style={{height: "100%", borderLeft: "10px solid #00CC00", textAlign: "left"}}>
            <h3>Deine Daten</h3>
            <ErrorInfoComponent errorMessage={this.state.errorMessage} infoMessage={this.state.infoMessage} warnMessage={this.state.warnMessage}
                                onClearInfoMessage={() => this.setState({infoMessage: undefined})}
                                onClearErrorMessage={() => this.setState({errorMessage: undefined})}
                                onClearWarnMessage={() => this.setState({warnMessage: undefined})}/>
            <OverlayPanel ref={(el) => this.opIdShort = el} showCloseIcon>
                <div style={{marginBottom: 5}}>
                    SpielerID kannst du für Offlineturniere, z.B. in der Kneipe oder ähnliches, für die schnelle Anmeldung nutzen.
                </div>
            </OverlayPanel>
            <div style={{width: "100%", marginBottom: 20}}>
                    <span style={{width: 200, marginRight: 10}}>
                        SpielerID <i className="pi pi-question-circle" style={{marginLeft: 5, cursor: "pointer"}} onClick={(e) => this.opIdShort.show(e)}/> :
                    </span>
                <span>{this.props.profil.userIdShort}</span>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-name" value={this.state.name} onChange={(text) => this.setState({name: text})}
                             label={"Name"} required={true} width={"100%"}/>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-vorname" value={this.state.vorname} onChange={(text) => this.setState({vorname: text})}
                             label={"Vorname"} required={true} width={"100%"}/>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-email" value={this.state.email} onChange={(text) => this.setState({email: text})}
                             label={"Email"} required={true} width={"100%"}/>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-mobil" value={this.state.mobil} onChange={(text) => this.setState({mobil: text})}
                             label={"Mobil"} required={true} width={"100%"}/>
            </div>
            <div className="grid" style={{marginTop: 10}}>
                <div className="col" style={{textAlign: "left", marginLeft: "5px", fontSize: 12}}>
                    Wir benötigen deine Strasse, PLZ u. deinen Wohnort ausschließlich, sobald du über
                    darthelfer.de einen Pro-Account abschließen willst.<br/>
                    Du kannst Pro-User nur werden, wenn du einen deutschen Wohnsitz besitzt bzw. hier eine deutsche Adresse einträgst.
                </div>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-strasse" value={this.state.strasse} onChange={(text) => this.setState({strasse: text})}
                             label={"Strasse"} required={true} width={"100%"}/>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-plz" value={this.state.plz} onChange={(text) => this.setState({plz: text})}
                             label={"PLZ"} required={true} width={100}/>
            </div>
            <div style={{marginBottom: 5}}>
                <DHTextField id="id-ort" value={this.state.ort} onChange={(text) => this.setState({ort: text})}
                             label={"Ort"} required={true} width={"100%"}/>
            </div>
            <div style={{marginBottom: 5}}>
                <DHButtonSave label="Speichern" onClick={() => this.save()} working={false}/>
            </div>
            <hr/>
            <span style={{fontSize: 12}}>Es werden die letzten 20 Bewertungen deiner Onlinespiele berücksichtigt.</span>
            <div style={{width: "100%", marginTop: 20}}>
                <span>Bewertung deiner Bildqualität</span>
                <br/>
                <span style={{fontSize: 12}}>Gesamtanzahl deiner erhaltenen Bildbewertungen:{this.props.profil.bewertung.anzahlRatingsBildqualitaet}</span>
                <ReactStars
                    value={this.props.profil.bewertung.bildqualitaet}
                    count={5}
                    size={25}
                    isHalf={true}
                    edit={false}
                    activeColor="#ffd700"/>
            </div>
            <div style={{width: "100%", marginTop: 20}}>
                <span>Bewertung deiner Tonqualität</span>
                <br/>
                <span style={{fontSize: 12}}>Gesamtanzahl deiner erhaltenen Tonbewertungen: {this.props.profil.bewertung.anzahlRatingTonqualitaet}</span>
                <ReactStars
                    value={this.props.profil.bewertung.tonqualitaet}
                    count={5}
                    size={25}
                    isHalf={true}
                    edit={false}
                    activeColor="#ffd700"/>
            </div>
        </div>
    }
}

DeineDatenAendern.propTypes = {
    profil: PropTypes.object.isRequired,
    callbackRefresh: PropTypes.func.isRequired,
};


export default DeineDatenAendern;
